import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "D:/java/\u4E00\u7F51\u901A\u529E(\u529E\u4E8B\u5927\u53852.0)/\u4E00\u7F51\u901A\u529E\u524D\u7AEFPC/pc/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.array.find";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import draggable from "vuedraggable";
import { mapGetters, mapActions } from "vuex";
import { getSubjectList, getSubjectInfo } from "@/api/managementCenter/themeManage";
export default {
  name: "subjectdl",
  components: {
    draggable: draggable
  },
  props: ["childModules"],
  data: function data() {
    return {
      baseUrl: process.env.BASE_URL,
      subjectData: {},
      subData: [],
      itemData: [],
      activeName: "1",
      activeIndex: 0,
      span: 1,
      col: 4,
      changed: false,
      dataShow: true,
      iconStr: "el-icon-arrow-down"
    };
  },
  created: function created() {
    var subject = this.moduleList.find(function (item) {
      return item.cardType === "SUBJECT";
    });

    if (subject) {
      this.subjectData = JSON.parse(JSON.stringify(subject.cardModules[0]));
    } else {
      this.subjectData = this.childModules;
    }

    this.getSubjectData();
  },
  computed: _objectSpread({}, mapGetters(["moduleList"])),
  methods: {
    getSubjectData: function getSubjectData() {
      var _this = this;

      var obj = {
        current: 1,
        size: 100
      };
      getSubjectList(obj).then(function (res) {
        _this.subData = res.data.data.records;
        _this.activeName = _this.subData[0].id;

        _this.handleClick();
      });
    },
    tranClick: function tranClick(blo) {
      if (blo) {
        this.dataShow = true;
        this.iconStr = "el-icon-arrow-down";
      } else {
        this.dataShow = false;
        this.iconStr = "el-icon-arrow-up";
      }
    },
    handleWidth: function handleWidth(col) {
      switch (col) {
        case 1:
          return "100%";

        case 2:
          return "50%";

        case 3:
          return "33.3%";

        case 4:
          return "25%";

        case 5:
          return "20%";

        case 6:
          return "16.6%";

        default:
          return "50%";
      }
    },
    handleClick: function handleClick() {
      var _this2 = this;

      getSubjectInfo(this.activeName).then(function (res) {
        _this2.itemData = res.data.data.selectedServes;
      });
    },
    goServe: function goServe(item) {
      var routeData = this.$router.resolve({
        path: "/ServeCenterDetail?id=".concat(item.serve_id)
      });
      window.open(routeData.href);
    }
  },
  watch: {},
  filters: {}
};